/** External destinations, in one place so a repo rename is a one-line change. */

export const TEMPLATE_REPO = "https://github.com/qureai/fastapi-vite-startecode-temlate";
export const BLOCKS_REPO = "https://github.com/qureai/qure-backend-blocks";
